import { apiRequest } from './http';
import type {
  ApiItemResponse,
  MaritimeDashboardRecord,
  MaritimeExchangeRecord,
  PartnerMappingDefinitionRecord,
  ProcessMaritimeMessageRequest,
} from '../types/api';

export const maritimeApi = {
  dashboard: async () => (await apiRequest<ApiItemResponse<MaritimeDashboardRecord>>('/maritime/dashboard')).data,
  mappings: async () => (await apiRequest<ApiItemResponse<PartnerMappingDefinitionRecord[]>>('/maritime/mappings')).data,
  process: async (payload: ProcessMaritimeMessageRequest) =>
    (await apiRequest<ApiItemResponse<MaritimeExchangeRecord>>('/maritime/messages/process', {
      method: 'POST',
      body: JSON.stringify(payload),
    })).data,
  replay: async (ids: string[], reason: string) =>
    (await apiRequest<ApiItemResponse<MaritimeExchangeRecord[]>>('/maritime/exchanges/replay', {
      method: 'POST',
      body: JSON.stringify({ ids, reason }),
    })).data,
};
